import StageView from './stage-view'

export default StageView
